import React, { useState, useContext } from "react";
import "./SignInForm.css";
import { useMutation } from "@apollo/client";
import { LOGIN_USER } from "./queries";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../../AuthContext";
import Button from "../../../Button";

export default function SignInForm() {
  const history = useHistory();
  const { setUser } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(undefined);

  const [loginUser] = useMutation(LOGIN_USER);

  function handleSubmit(e) {
    e.preventDefault();

    loginUser({
      variables: {
        username: username,
        password: password,
      },
    })
      .then((data) => {
        const sessionKey = data.data.loginUser.sessionKey;

        Cookies.set("sessionid", sessionKey, { expires: 14 });
        Cookies.set("loggedIn", true, { expires: 14, httpOnly: false });

        const user = data.data.loginUser.user;
        setUser(user);
        history.push("/");
      })
      .catch((error) => {
        setErrorMessage(error.graphQLErrors[0].message);
      });
  }

  return (
    <div className="signin-page-container">
      <div className="signin-container">
        <form id="signin-form" className="signin-form" onSubmit={handleSubmit}>
          <div className="signin-form-row">
            <p>* Username field is case sensitive.</p>
            <label htmlFor="signin-username" className="signin-label">
              Username
            </label>
            <input
              id="signin-username"
              name="signin-username"
              className="signin-input"
              placeholder="Enter Username Here"
              required
              value={username}
              type="text"
              onChange={(event) => {
                setUsername(event.target.value);
              }}
            />

            <label htmlFor="signin-password" className="signin-label">
              Password
            </label>
            <input
              id="signin-password"
              name="signin-password"
              className="signin-input"
              placeholder="Enter Password Here"
              required
              value={password}
              type="password"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
            />

            {errorMessage !== undefined ? (
              <p className="signin-error">{errorMessage}</p>
            ) : null}

            <a href="/forgot-password">Forgot Password</a>
          </div>
          <br />
          <Button form={true}>Login</Button>
        </form>
      </div>
    </div>
  );
}
